export default {
  // spaces (areas) -----------------------------------------------------------
  async respondToSpaceInvite({dispatch}, [response, data]) { //switch space
    dispatch('mixpanelTrack', ['Respond To Space Invite', {
      'Response': response,
      ...data
    }])
  },
  async inviteUsersToSpace({dispatch}, [users, validAdds, invalidAdds]) {
    dispatch('mixpanelTrack', ['Invite Users To Space', {
      'User Emails': users,
      'Successfully Invited': validAdds,
      'Error Inviting': invalidAdds
    }])
  },
  async inviteGuestToSpaceLink({dispatch}) { //open spaces
    dispatch('mixpanelTrack', ['Copy Invite Guest To Space Link'])
  },
  async inviteGuestToSpaceEmail({dispatch}, [users, validAdds, invalidAdds]) { //open spaces
    dispatch('mixpanelTrack', ['Invite Guest/s To Space By Email', {
      'User Emails': users,
      'Successfully Invited': validAdds,
      'Error Inviting': invalidAdds
    }])
  },

  // rooms --------------------------------------------------------------------
  async inviteToRoom({rootGetters, dispatch}, [user, userInAnotherSpace = false, userWasPinned = false]) {
    let ifInHub = rootGetters.getIfCurrentUsersRoomIsHub
    let data = {
      'User In Another Space': userInAnotherSpace,
      'User Was Pinned': userWasPinned,
      'Invited User': user
    }
    if(ifInHub) {
      dispatch('mixpanelTrack', ['Invite to new room', data])
    } else {
      dispatch('mixpanelTrack', ['Invite to existing room', data])
    }
  },
  async inviteGuestToRoomLink({dispatch}, [roomId]) {
    dispatch('mixpanelTrack', ['Copy Invite Guest To Room Link', {
      'Room Id': roomId
    }])
  },
  async inviteGuestToRoomEmail({dispatch}, [users, validAdds, invalidAdds]) {
    dispatch('mixpanelTrack', ['Invite Guest/s To Room By Email', {
      'User Emails': users,
      'Successfully Invited': validAdds,
      'Error Inviting': invalidAdds
    }])
  },
  async inviteToJumpSpace({dispatch}, [type, user, jumpSpace]) {
    dispatch('mixpanelTrack', [`Invite to Room in Jump Space ${type}`, {
      'Type': type,
      'Invited User': user,
      'Portal Data': jumpSpace,
      'Jump Space Id': jumpSpace?.location?.reference,
      'Jump Space Name': jumpSpace?.location?.name
    }])
  },
  async respondToRoomInvite({dispatch}, [type, notification, message = false]) {
    let data = {
      'Response Type': type,
      'Notification': notification
    }
    if(message) data['Message'] = message
    dispatch('mixpanelTrack', [`Respond To Room Invite`, data])
  },

  // pinning
  async pinUser({dispatch}, [userId]) {
    dispatch('mixpanelTrack', ['Pin User', {
      'Pinned User Id': userId
    }])
  },
  async cancelPinUser({dispatch}, [pinId, userId]) {
    dispatch('mixpanelTrack', ['Cancel Pin User', {
      'Pinned User Id': userId,
      'Pin Id': pinId
    }])
  },

  async createBroadcast({dispatch}, data) {
    dispatch('mixpanelTrack', ['Create Broadcast', {
      'Broadcast Data': data,
    }])
  },
  async deleteBroadcast({dispatch}, id) {
    dispatch('mixpanelTrack', ['Delete Broadcast', {
      'Broadcast Id': id,
    }])
  },
}
